import { render, staticRenderFns } from "./after-sales-modal.vue?vue&type=template&id=baaa4010&"
import script from "./after-sales-modal.vue?vue&type=script&lang=js&"
export * from "./after-sales-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports